import Forward from "@/views/Forward.vue";

export default (rootPath) => {
  return [
    {
      path: "",
      component: Forward,
      redirect: `${rootPath}/list`,
      hidden: true,
      children: [
        {
          path: "list",
          component: () => import("@/views/table/ExhibitionsTable.vue"),
          meta: { title: "Список аудио", activeMenuParent: true },
          hidden: true,
        },
        {
          path: "create/:hallId",
          component: () => import("@/views/forms/ExhibitionsForm.vue"),
          meta: { title: "Добавить аудио", activeMenuParent: true },
          hidden: true,
        },
        {
          path: "edit/:id",
          component: () => import("@/views/forms/ExhibitionsForm.vue"),
          meta: { title: "Редактировать аудио", activeMenuParent: true },
          hidden: true,
        },
      ],
    },
  ];
};
